import React, { useState } from 'react';
import styled from "styled-components";
import { useFormikContext } from 'formik';
import { H1 } from 'components/text';
import { FieldGroup, RadioButton } from 'components/forms';
import Infobox from 'components/infobox';
import { individual_requirements, entity_requirements } from './requirements';

const ToggleButton = styled.button`
  all: unset;
  cursor: pointer;
  color: ${(props) => props.theme.cyan};
  font-weight: ${(props) => props.theme.fontWeightBold};
  padding-left: ${(props) => props.theme.paddingS};
  padding-bottom: ${(props) => props.theme.paddingS};

  &:hover {
    color: ${(props) => props.theme.darkestCyan};
    text-decoration: underline;
  }
`

const EcpStatus = () => {
  const [showMoreOptions, setShowMoreOptions] = useState(false)
  const { values } = useFormikContext();
  const isEntity = values.account_type === 'entity';
  const requirements = isEntity ? entity_requirements : individual_requirements;

  

  return (
    <>
      {
        isEntity ? 
        <>
          <H1>Do you qualify for Institutional Negotiated Trading?</H1>       
          <Infobox>
            <strong>You must meet at least one condition below to qualify for negotiated trading.</strong>
          </Infobox>
        </> : <H1>Do you qualify as an Eligible Contract Participant (“ECP”)*?</H1>
      }
      <FieldGroup name="ecp_status" label="">
        {
          isEntity ? <RadioButton name="ecp_status" value=""> No, continue my application</RadioButton> 
          : <RadioButton name="ecp_status" value="">No, I am a retail investor and do not qualify as an ECP.</RadioButton>
        }
        {
          requirements.slice(0, 2).map((option) => (
            <RadioButton name="ecp_status" value={option.name} key={option.name}>
              {option.label}
            </RadioButton>
          ))
        }
        {
          requirements.length > 2 &&
          <ToggleButton
            type="button"
            onClick={() => setShowMoreOptions(!showMoreOptions)}
          >
            {showMoreOptions ? '-' : '+'} Show {showMoreOptions ? 'less' : 'more'}
          </ToggleButton>
        }
        {
          requirements.length > 2 &&
          showMoreOptions &&
          requirements.slice(2).map((option) => (
            <RadioButton name="ecp_status" value={option.name} key={option.name}>
              {option.label}
            </RadioButton>
          ))
        }
      </FieldGroup>
    </>
  );
};

export default EcpStatus;
